// extracted by mini-css-extract-plugin
export default {"news":"ProjectNewsSinglePage_news__j6cfO","news__bread_crumbs":"ProjectNewsSinglePage_news__bread_crumbs__Fu+gT","news__body":"ProjectNewsSinglePage_news__body__pOIW4"};